<template>
  <div class="container">
    <!-- <div class="box" @click="refrash()">
      <img :src="$store.getters.getUrl('ob_header_img1')" alt="" />
      <p>线路中心</p>
    </div> -->
    <img :src="$store.getters.getUrl('ky_header_logo')" :style="{'width':$store.getters.getKey('width')&&$store.getters.getKey('width'),'height':$store.getters.getKey('height')&&$store.getters.getKey('height')}" alt="" class="logo" />
    <!-- <div class="box" @click="openPop()">
      <img :src="$store.getters.getUrl('ob_header_img2')" alt="" />
      <p>信任教程</p>
    </div> -->
    <transition name="fade">
      <TrustTeachPop v-if="TrustTeachPopShow" @closePop='closePop' :imgUrl="teach"></TrustTeachPop>
    </transition>
  </div>
</template>


<script>
import TrustTeachPop from "../../../components/trustTeachPop.vue"
export default {
  data() {
    return {
      TrustTeachPopShow: false
    };
  },
  components: {
    TrustTeachPop
  },
  computed: {
    //备份方案，教程配置了就读配置，没配置读默认图片
    teach() {
      return (
        this.$store.getters.getUrl("ob_teach")
      );
    },
  },
  methods: {
    refrash() {
      window.location.reload()
    },
    closePop(closePop) {
      this.TrustTeachPopShow = closePop;
      document.body.removeAttribute('style')
    },
    openPop() {
      this.TrustTeachPopShow = true
      document.querySelector('body').setAttribute('style', 'overflow:hidden;')
    }
  }
};
</script>

<style lang="scss" scoped>
.container {
  width: 100%;
  height: 91px;
  background: rgba(0, 0, 0, 0);;
  display: flex;
  align-items: center;
  justify-content: center;
  padding:0 20px;
  padding-top:20px;
  box-sizing: border-box;
  .logo {
    width: 480px;
    height: 100px;
  }
  .fade-enter-active, .fade-leave-active {
    transition: opacity 0.3s
  }
  .fade-enter, .fade-leave-to  {
      opacity: 0
  }
}
</style>